import { ReportParams } from './interface'
import { API } from '@/services/api-onix'

export const post = async (
  filtros: Record<string, any>
): Promise<{
  conteudo: string
  sucesso: boolean
}> => {
  try {
    const response = await API.post<ReportParams>('/Relatorios', filtros, {
      headers: {
        'Content-Type': 'application/json'
      }
    })

    return {
      ...response
    }
  } catch (error) {
    console.error('Erro ao solicitar relatorio:', error)
    return {
      conteudo: null,
      sucesso: false
    }
  }
}
